import { render, staticRenderFns } from "./ProjectPreview.vue?vue&type=template&id=67228159&scoped=true"
import script from "./ProjectPreview.vue?vue&type=script&lang=js"
export * from "./ProjectPreview.vue?vue&type=script&lang=js"
import style0 from "./ProjectPreview.vue?vue&type=style&index=0&id=67228159&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67228159",
  null
  
)

export default component.exports